import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(activity)/black-friday/ClientPage.tsx");
